/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateLeadDecisionRequestBidirectionalActionDetailsDetailsSelectionsInner
 */
export interface UpdateLeadDecisionRequestBidirectionalActionDetailsDetailsSelectionsInner {
    /**
     * 
     */
    name: string;
    /**
     * 
     */
    selected_option: string;
}

/**
 * Check if a given object implements the UpdateLeadDecisionRequestBidirectionalActionDetailsDetailsSelectionsInner interface.
 */
export function instanceOfUpdateLeadDecisionRequestBidirectionalActionDetailsDetailsSelectionsInner(value: object): value is UpdateLeadDecisionRequestBidirectionalActionDetailsDetailsSelectionsInner {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('selected_option' in value) || value['selected_option'] === undefined) return false;
    return true;
}

export function UpdateLeadDecisionRequestBidirectionalActionDetailsDetailsSelectionsInnerFromJSON(json: any): UpdateLeadDecisionRequestBidirectionalActionDetailsDetailsSelectionsInner {
    return UpdateLeadDecisionRequestBidirectionalActionDetailsDetailsSelectionsInnerFromJSONTyped(json, false);
}

export function UpdateLeadDecisionRequestBidirectionalActionDetailsDetailsSelectionsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateLeadDecisionRequestBidirectionalActionDetailsDetailsSelectionsInner {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'selected_option': json['selected_option'],
    };
}

export function UpdateLeadDecisionRequestBidirectionalActionDetailsDetailsSelectionsInnerToJSON(json: any): UpdateLeadDecisionRequestBidirectionalActionDetailsDetailsSelectionsInner {
    return UpdateLeadDecisionRequestBidirectionalActionDetailsDetailsSelectionsInnerToJSONTyped(json, false);
}

export function UpdateLeadDecisionRequestBidirectionalActionDetailsDetailsSelectionsInnerToJSONTyped(value?: UpdateLeadDecisionRequestBidirectionalActionDetailsDetailsSelectionsInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'selected_option': value['selected_option'],
    };
}

